// extracted by mini-css-extract-plugin
export default {"form":"edit_position_form-module___form___a819c8f9"};